import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from '../getBaseQuery';
import { ApiNames } from '../names';
export const researchApi = createApi({
    reducerPath: 'apiResearch',
    baseQuery: getBaseQuery(ApiNames.RESEARCH),
    endpoints: () => ({})
});
